var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.77,
    height: 18.77,
    viewBox: "0 0 18.77 18.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp-brands",
    d: "M15.959,34.728A9.3,9.3,0,0,0,1.32,45.952L0,50.77l4.931-1.295a9.273,9.273,0,0,0,4.445,1.131h0a9.242,9.242,0,0,0,6.578-15.879ZM9.381,49.04a7.717,7.717,0,0,1-3.938-1.077L5.162,47.8l-2.924.767.779-2.853-.184-.293A7.746,7.746,0,1,1,17.2,41.305,7.817,7.817,0,0,1,9.381,49.04Zm4.24-5.79c-.23-.117-1.374-.679-1.588-.754s-.369-.117-.524.117-.6.754-.737.913-.272.176-.5.059a6.326,6.326,0,0,1-3.163-2.765c-.239-.411.239-.381.683-1.269a.431.431,0,0,0-.021-.406c-.059-.117-.524-1.261-.716-1.726s-.381-.39-.524-.4-.289-.008-.444-.008a.861.861,0,0,0-.62.289,2.612,2.612,0,0,0-.813,1.94,4.553,4.553,0,0,0,.947,2.4,10.385,10.385,0,0,0,3.972,3.511,4.548,4.548,0,0,0,2.79.582,2.38,2.38,0,0,0,1.567-1.106,1.944,1.944,0,0,0,.134-1.106C14.006,43.421,13.851,43.363,13.621,43.25Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFooter);
export default __webpack_public_path__ + "static/media/whatsapp-footer.8c54478887fe92cb50741d26e516b1a4.svg";
export { ForwardRef as ReactComponent };